export default "__VITE_ASSET__ji7thZ6L__"